import type { UAPStyleMap } from '../../@types';

const getBingSearchPlacementBaseStyles = (_theme?: object): UAPStyleMap => ({
  placementCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: '#fff',
    margin: 'auto',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },
  placementTextContainer: {
    margin: '4px 8px 0 8px',
    fontSize: 10,
    lineHeight: '16px',
    color: '#0078d4',
    cursor: 'pointer',
    overflow: 'hidden',
    '&:hover': {
      color: '#004578',
    },
    '& .logo-and-text-container': {
      display: 'flex',
      flexDirection: 'row',
      paddingBottom: 8,
      '& .logo-text': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  placementShortHeadline: undefined,
  placementLongHeadline: {
    minHeight: 28,
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '24px',
    overflow: 'hidden',
    width: '100%',
  },
  placementFinalUrl: {
    height: 20,
    fontSize: 14,
    color: '#0b6a0b',
  },
  placementDescriptionContainer: {
    display: 'flex',
  },
  placementAdsLabel: {
    position: 'static !important',
    color: '#767676 !important',
    border: '1px solid #ddd !important',
    margin: '0 4px 0 0 !important',
    display: 'inline',
    opacity: '100% !important',
    padding: '0 2px !important',
    maxHeight: 16,
    fontWeight: 600,
    lineHeight: 1,
    borderRadius: '6px !important',
  },
  placementDescription: {
    color: '#333',
    display: 'inline-block',
    fontSize: 13,
    flexGrow: 1,
    overflow: 'hidden',
  },
});


export const getResponsiveBingSearchTextPlacementStyles = (theme: object) => {
  const { placementCard, placementFinalUrl, ...baseStyles } = getBingSearchPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      minHeight: 110,
      padding: '8px 16px',
      alignItems: 'flex-start',
      background: 'transparent',
      '& .card-parent': {
        width: '100%',
      },
      '& .placement-card-content': {
        width: '100%',
        display: 'block',
        overflow: 'hidden',
        boxSizing: 'border-box',
      },
    },

    placementFinalUrl: {
      ...placementFinalUrl,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    placementLogoContainer: {
      paddingRight: 8,
      '& .cropped-image-view': {
        borderRadius: 6,
      },
    },
  };
  return styles;
};
